import CustomButton from '../../shared/custom-button/custom-button';
import { Link } from 'react-router-dom';
import React from 'react';
import Shield from '@svg/shield.svg?react';


export const ExternalUnauthorizedMessage = () => {

    const learnMoreLink = 'https://www.business.att.com/products/att-dynamic-defense.html?WT.srch=1&source=ECPS0000000PSM00P&wtpdsrchprg=AT%2526T%2520ABS&wtpdsrchgp=ABS_SEARCH&' +
        'wtPaidSearchTerm=at%26t%20dynamic%20defense&wtpdsrchpcmt=at%26t%20dynamic%20defense&kid=kwd-2311374657359&cid=21251041399&schParam=&LNS=PS_NT_ADI_BND_1117/&' +
        'customer_id=1946426239&gclsrc=aw.ds&gad_source=1&gad_campaignid=21251041399&gclid=EAIaIQobChMIj_Pq54qIjgMV107_AR2YOy2HEAAYASAAEgJ3ivD_BwE#/';

    const learnMoreBtn = <Link to={learnMoreLink} target="_blank" rel="noreferrer" className={'knowledge-base-link'} >
            <CustomButton label={'Learn More'} className="primary-btn action-btn"/>
    </Link>;

    return (
        <div className="unauthorized-body" style={{width: 520}}>
            <div className="unauthorized-content">
                <div className="unauthorized-icon-background">
                    <Shield/>
                </div>
                <div className="unauthorized-message">Interested in AT&T Dynamic</div>
                <div className="unauthorized-message">Defense?</div>
                <div className="unauthorized-message-desc">
                    <div>See how you can protect your business with</div>
                    <div>AT&T’s advanced network security solution.</div>
                </div>
            </div>
            <div className="btn-wrapper">
                {learnMoreBtn}
            </div>
        </div>
    );
};